/* eslint-disable jsx-a11y/alt-text */
import Image, { ImageLoaderProps, ImageProps } from 'next/image';

const DEFAULT_IMAGE_QUALITY = 93;

interface CustomImageProps extends ImageProps {
    quality?: number;
}

const contentfulImageLoader = ({ src, width, quality }: ImageLoaderProps) => {
    const url = new URL(src);
    // Remove existing query parameters related to image optimization
    url.searchParams.delete('w');
    url.searchParams.delete('q');

    // Set new query parameters
    url.searchParams.set('w', width.toString());
    const adjustedQuality = width < 700 ? 75 : quality || DEFAULT_IMAGE_QUALITY;
    url.searchParams.set('q', adjustedQuality.toString());

    return url.toString();
};

const CustomImage: React.FC<CustomImageProps> = ({ quality = DEFAULT_IMAGE_QUALITY, ...rest }) => {
    const loader =
        typeof rest.src === 'string' && rest.src.startsWith('https://')
            ? contentfulImageLoader
            : undefined;
    return (
        <Image
            loader={loader}
            quality={quality}
            sizes="(max-width: 600px) 100vw, (max-width: 1200px) 50vw, 33vw"
            {...rest}
        />
    );
};

export default CustomImage;
